import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "destination"]

  sync() {
    const value = this.sourceTarget.value
    this.destinationTargets.forEach(target => target.value = value)
  }
}
